import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Box, Typography, styled } from '@mui/material'
import axios from 'axios'
import { Loading } from '../components/ui'
import { NotFoundData } from '../scenes'
import DEFAULT from '../config/default'

const PageTrackingServientrega = () => {
    const { numeroGuia } = useParams<{ numeroGuia: string }>()
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const validateAndRedirect = async () => {
            if (!numeroGuia) {
                setError('Número de guía no proporcionado')
                return
            }

            try {
                await axios({
                    method: 'POST',
                    url: 'https://apim-servientrega-prd.azure-api.net/portal-rastreo/api/Envio/InsertarToken',
                    headers: {
                        'Ocp-Apim-Subscription-Key': '9c125dc6aeaf4a3a9277e50456661243',
                        'Content-Type': 'application/json'
                    },
                    data: {
                        numeroGuia: numeroGuia
                    },
                    timeout: 10000
                })
                window.location.href = `https://mobile.servientrega.com/WebSitePortal/RastreoEnvioDetalle.html?Guia=${numeroGuia}`
                
            } catch (error: any) {
                const courier = (DEFAULT.project.couriers || []).find(
                    (c) => c.name === 'servientrega'
                )
                window.location.href = `${courier?.url}detalle?id=${numeroGuia}`
            }

        }

        validateAndRedirect()
    }, [numeroGuia])

    if (error) {
        return (
            <LayoutStyled>
                <NotFoundData>
                    <Typography variant="h6" color="error" gutterBottom>
                        Opps!
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        {error}
                    </Typography>
                </NotFoundData>
            </LayoutStyled>
        )
    }

    return (
        <Loading
            message={
                <>
                    Validando enlace de tracking...
                    <br />
                    <strong>Guía: {numeroGuia}</strong>
                </>
            }
        />
    )
}

const LayoutStyled = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
}))

export default PageTrackingServientrega

